// @flow
import React, { PureComponent } from 'react';
import SocialCardNavigator from 'components/social/SocialCardNavigator';
import type { SocialContent } from 'types/SocialContent';
import { STATUS_SUCCESS } from 'constants/statusConstants';
import LazyLoad from 'components/fragments/LazyLoad';
import { Link } from 'react-router-dom';
import { handleTagEvent } from 'utils/tagManagerUtils';
import type { liensRsType } from 'types/Settings';

export type StateProps = {
  status: string,
  posts: SocialContent[],
  titleClub: string,
  liens_rs: liensRsType
};

export type DispatchProps = {
  fetchInstagramPosts: () => void,
  fetchFacebookPosts: () => void,
  fetchTwitterPosts: () => void,
  fetchYoutubePosts: () => void
};

type Props = StateProps & DispatchProps;

class SocialHub extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchInstagramPosts();
    this.props.fetchFacebookPosts();
    this.props.fetchTwitterPosts();
    this.props.fetchYoutubePosts();
  }

  render() {
    const {
      liens_rs: {
        fb_lien,
        twitter_lien,
        instagram_lien,
        youtube_lien,
        flickr_lien,
        linkedin_lien,
        twitch_lien,
        snapchat_lien,
        tik_tok_lien
      },
      titleClub
    } = this.props;

    if (
      (fb_lien === '' &&
        twitter_lien === '' &&
        instagram_lien === '' &&
        youtube_lien === '' &&
        flickr_lien === '' &&
        linkedin_lien === '' &&
        twitch_lien === '' &&
        snapchat_lien === '' &&
        tik_tok_lien === '') ||
      this.props.posts.length === 0
    ) {
      return null;
    }
    return (
      <section className="section section-dark live-feed">
        <LazyLoad>
          <div className="container">
            <div className="row">
              <div className="col col-md-4 col-lg-3">
                <h2 className="live-feed__title mb-2">Suivez l’actualité en direct.</h2>
                <p className="live-feed__desc ft-secondary mb-4">
                  Retrouvez toute notre actualité sur les réseaux sociaux.
                </p>
                <p className="mb-4">
                  {fb_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={fb_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Facebook de ${this.props.titleClub}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', 'facebook')}
                    >
                      <i className="icon icon-facebook" />
                    </a>
                  )}
                  {twitter_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={twitter_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Twitter de ${this.props.titleClub}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', 'twitter')}
                    >
                      <i className="icon icon-twitter" />
                    </a>
                  )}
                  {instagram_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={instagram_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Instagram de ${this.props.titleClub}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', 'instagram')}
                    >
                      <i className="icon icon-instagram" />
                    </a>
                  )}
                  {youtube_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={youtube_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Youtube de ${titleClub}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', 'youtube')}
                    >
                      <i className="icon icon-youtube" />
                    </a>
                  )}
                  {flickr_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={flickr_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Flickr de ${titleClub}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', 'flickr')}
                    >
                      <i className="icon icon-flickr" />
                    </a>
                  )}
                  {linkedin_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={linkedin_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Linkedin de ${titleClub}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', 'linkedin')}
                    >
                      <i className="icon icon-linkedin" />
                    </a>
                  )}
                  {snapchat_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={snapchat_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Snapchat de ${titleClub}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', 'snapchat')}
                    >
                      <i className="icon icon-snapchat" />
                    </a>
                  )}
                  {tik_tok_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={tik_tok_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page TikTok de ${titleClub}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', 'tiktok')}
                    >
                      <i className="icon icon-tik-tok" />
                    </a>
                  )}
                  {twitch_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={twitch_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Twitch de ${titleClub}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', 'twitch')}
                    >
                      <i className="icon icon-twitch" />
                    </a>
                  )}
                </p>
              </div>
              {this.props.posts.length > 0 && (
                <SocialCardNavigator
                  liensRs={this.props.liens_rs}
                  socialCards={this.props.posts}
                  showCards={this.props.status === STATUS_SUCCESS}
                />
              )}
            </div>
            {this.props.posts.length > 0 && (
              <div className="row">
                <div className="col col-md-4 col-lg-3">
                  <Link to="/social-wall" className="btn btn--primary">
                    <i className="icon icon-publications is-inline" />
                    <span>Voir les publications</span>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </LazyLoad>
      </section>
    );
  }
}

export default SocialHub;
